import firebase from "firebase/app";

// These imports load individual services into the firebase namespace.
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyBbMV7q7iiKli5SDvpRSmLe6Ys7AAYyxnY",
  authDomain: "engineer-ae17e.firebaseapp.com",
  databaseURL: "https://engineer-ae17e.firebaseio.com",
  projectId: "engineer-ae17e",
  storageBucket: "engineer-ae17e.appspot.com",
  messagingSenderId: "93857944365",
};

const app = firebase.initializeApp(config);
const createAuthApp = firebase.initializeApp(config, "createAuth");
app.firestore().enablePersistence({ synchronizeTabs: true });

export const firedb = app.database();
export const fireStore = app.firestore();
export const connectedRef = app.database().ref(".info/connected");
export const storage = app.storage();
export const auth = app.auth();
export const createAuth = createAuthApp.auth();
export function updateAuditLog(
  type,
  group,
  user,
  jobNo,
  projectId,
  action,
  data,
  customer
) {
  app
    .firestore()
    .collection("AuditLog")
    .add({
      type: type || null,
      group: group || null,
      user: user || null,
      jobNo: jobNo || null,
      projectId: projectId || null,
      customer: customer || null,
      data: data || null,
      action: action || null,
      time: Date.now(),
    });
}
export function sendEmail(to, subject, body) {
  console.log("send email");
  app
    .firestore()
    .collection("Emails")
    .add({
      to: to || null,
      subject: subject || null,
      body: body || null,
    })
    .then((resp) => {
      console.log(resp);
    })
    .catch((error) => {
      console.log(error);
    });
}



// WEBPACK FOOTER //
// ./src/firebase.js